const WENDEZEIT = 'Dienstfahrt/Wendezt.';
const FAHREN = 'Fahren';

export default {
  /**
   * This function is called while looping through dutyActivities to create a list of duty activities whose activities
   * might merge several items. Each item can have child objects within the children attribute.
   *
   * shouldMergeDutyActivity must check what happens with the currentDutyActivity. However the function does not
   * manipulate data but needs to return an advice what should be done (described in return)
   *
   * @param {Object} MeinDienst module configuration object
   * @param {Object} accumulator The duty activity which may accumulate other duty activities
   * @param {Object} currentDutyActivity The current duty activity when looping through all activities
   * @param {Array} dutyActivities all duty activities
   * @param {Number} currentIndex the current index when looping through the duty activities
   * @returns string one of the following
   *                 new: that is the current item is used right away
   *                 mergeToAccumulator: the next two items are merged with the current item
   */
  shouldMergeDutyActivity: ({ moduleConfig, accumulator, currentDutyActivity, dutyActivities, currentIndex }) => {
    let i = currentIndex;

    if (!accumulator) {
      return 'mergeToAccumulator';
    } else {
      // "Spez" von Jan Alfaenger
      // Wie bereits von Till angemerkt, soll in der zusammengefassten Ansicht links nur dann
      // ein neuer Eintrag stehen, wenn
      // 1) sich der Umlauf ändert und/oder
      // 2) sich die Linie ändert und/oder
      // 3) sich die (Ober-)Tätigkeitsart ändert und/oder
      // 4) eine zeitliche Lücke zum nächsten Dienststück vorhanden ist (Dienstteilung).

      if (
        accumulator.course === currentDutyActivity.course &&
        accumulator.line === currentDutyActivity.line &&
        accumulator.blockcode === currentDutyActivity.blockcode &&
        accumulator.toMinutesAfterMidnight === currentDutyActivity.fromMinutesAfterMidnight &&
        // Remark Marcel:
        // According to Jan's definition in 3, we actually had to add the following condition
        // However this is not right and it would lead no collapsible cards
        // accumulator._dutyActivityType === currentDutyActivity._dutyActivityType &&
        accumulator._dutyActivityGroup === currentDutyActivity._dutyActivityGroup
      ) {
        // as long as these conditions are met, the duty activity can be collapsed and thus merged to the accumulator
        // object which collects collapsible items within the children attribute
        return 'mergeToAccumulator';
      }

      return 'new'; // instruction to create a new accumulator, that is a new outer item (collapsible card) is created
    }
  },
  /**
   * Returns the last duty activity in the sorted list of duty activities.
   * Defaults to return the last activity within the array of activities
   *
   * LVB does not use the last item to determine the end time in some cases.
   * However, the logic is not clear.
   * It seems like LEIB, SANGAusfahrt are blacklisted as last activity within LVB.
   * @param {Object} MeinDienst module configuration object
   * @param {*} dutyActivities
   * @returns the last relevant duty activity
   */
  getLastActivity: ({ moduleConfig, dutyActivities }) => {
    //return dutyActivities[dutyActivities.length - 1];
    return dutyActivities.reverse().find((a) => !['LEIB', 'SANGAusfahrt'].includes(a._endStop ? a._endStop.shortname : 'shortname not defined on endstop'));
  },

  /**
   * Returns the track selection applied when the user chooses a duty activity.
   * Only set properties are getting used. Therefore the default case does not set the track property.
   * @param dutyActivity
   * @returns {{startToMinutesAfterMidnight, endToMinutesAfterMidnight, line,track, blockcode}}
   */
  getTrackSpecificationFromDutyActivity: (dutyActivity) => {
    const specs = {
      // track: dutyActivity.blockcode, // bei LVB steht der Umlauf im Blockcode, welcher für die Filterung verwendet werden muss
      line: dutyActivity.line,
      blockcode: dutyActivity.blockcode,
      startToMinutesAfterMidnight: dutyActivity.fromMinutesAfterMidnight,
      endToMinutesAfterMidnight: dutyActivity.toMinutesAfterMidnight,
    };
    console.debug('specs=', JSON.stringify(specs, null, 2));
    return specs;
  },
};
